import { useState } from "react";
import { toast } from "react-toastify";
import toastr from "toastr";
import { EditorState } from "draft-js";
import axios from "axios";

const useMailBlast = () => {

  const [params, setParams] = useState({ type: "" });
  const [customers, setCustomers] = useState([]);

  const [selectedBasestations, setSelectedBasestations] = useState([]);
  const [selectedAccessPoints, setSelectedAccessPoints] = useState([]);

  const [accessPoints, setAccessPoints] = useState([]);
const [accessPointsLoading, setAccessPointsLoading] = useState(false);

  const [fetching, setFetching] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);

  const [subject, setSubject] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [body, setBody] = useState("");

  const [country, setCountry] = useState("");
  const [canned, setCanned] = useState("");

  const onSubjectChange = (e) => setSubject(e.target.value);
  const onCannedChange = (e) => setCanned(e.target.value);
  const onCountryChange = (e) => setCountry(e.target.value);
  const onTextChange = (e) => setBody(e.target.value);

  const onChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value });
  };

  const handleChange = async (option) => {

  const basestations = option || [];

  setSelectedBasestations(basestations);
  setSelectedAccessPoints([]);

  if (basestations.length > 2) {
    setAccessPoints([]);
    return;
  }

  if (!basestations.length) {
    setAccessPoints([]);
    return;
  }

  setAccessPointsLoading(true);

  try {

    const token = sessionStorage.getItem("token");

    const response = await axios.post(
      "https://api.tizeti.com/api/v1/callstation/access_points",
      {
        calledstation: basestations.map((b) => b.value),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const accessPointData =
      response.data.items ||
      response.data.data ||
      response.data ||
      [];

    const options = accessPointData.map((ap) => ({
      value: ap.id,
      label: ap.name,
    }));

    setAccessPoints(options);

  } catch (error) {

    console.error("Error fetching access points:", error);

  } finally {

    setAccessPointsLoading(false);

  }
};

  const handleAccessPointChange = (option) => {
    setSelectedAccessPoints(option || []);
  };

  const onSubmit = async () => {

    if (!selectedBasestations.length) {
      toast("Please select a basestation");
      return;
    }

    setFetching(true);

    const token = sessionStorage.getItem("token");

    try {

      let endpoint = "";
      let payload = {};

      if (selectedAccessPoints.length) {

        endpoint = "https://api.tizeti.com/api/v1/geniatech/access_point_users";

        payload = {
          type: params.type,
          access_point_id: selectedAccessPoints.map((ap) => ap.value)
        };

      } else {

        endpoint = "https://api.tizeti.com/api/v1/legacy/UsersByBasestation";

        payload = {
          type: params.type,
          basestations: selectedBasestations.map((b) => b.value)
        };

      }

      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setCustomers(response.data.items || response.data);

    } catch (error) {

      toast("Something went wrong!");
      console.error(error);

    } finally {
      setFetching(false);
    }
  };

  const sendEmail = async (param) => {

    setSendingEmail(true);

    try {

      const response = await axios.post(
        "https://api.tizeti.com/api/v1/mail/mailblast",
        param,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status === true) {

        toastr.success("Sent Successfully");

        setEditorState(EditorState.createEmpty());
        setSubject("");

      } else {
        toast.info("Unable to send message");
      }

    } catch (error) {

      toast("Something went wrong. Try later!");

    }

    setSendingEmail(false);
  };

  const submitForm = () => {};

  const onEditorStateChange = (editorStat) => {
    setEditorState(editorStat);
  };

  return {
  onChange,
  onSubmit,
  handleChange,
  handleAccessPointChange,
  selectedBasestations,
  selectedAccessPoints,
  accessPoints,
  accessPointsLoading,
  customers,
  fetching,
  sendEmail,
  sendingEmail,
  onEditorStateChange,
  submitForm,
  editorState,
  subject,
  onSubjectChange,
  onTextChange,
  body,
  country,
  onCountryChange,
  canned,
  onCannedChange,
};
};

export default useMailBlast;